import { paginationString } from '../helpers/getPaginationString'
import action from '../helpers/rest-client'
import { GetAllUsersOutDto } from '../types/user.dto'

const path = '/user'
class User {
  public new(payload) {
    return action
      .Post({
        url: path,
        body: { ...payload, roles: ['ADMIN'], comments: '', active: true },
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async edit({ idUser, body }) {
    return action
      .Patch({
        url: `${path}/${idUser}`,
        body: body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async deleteUserMedia(body) {
    console.log("deleteUserMedia", body)
    return action
      .Del({
        url: `${path}/delete-media`,
        body
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllUsersOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idUser }) {
    return action
      .Get({
        url: `${path}/${idUser}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getProfile() {
    return action
      .Get({
        url: `${path}/profile`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const user = new User()
export default user
